import { UserAdapters } from '../adapters';
import { UsersApi } from '../clients';

export const getUsersByIds = async (userIds) => {
  const response = await UsersApi.getUsersByIds(userIds);

  return UserAdapters.toGetUsersByIdsResult(response);
};
